import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Star } from "lucide-react";
import { SITE } from "@/lib/site";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-900 text-slate-300 mt-24 grain"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Link to="/" className="flex items-center gap-2">
              <div className="grid h-10 w-10 place-items-center rounded-md bg-white text-[var(--color-primary)] font-display font-black tracking-tighter">
                VW
              </div>
              <span className="font-display font-extrabold text-white text-lg">
                {SITE.short}
              </span>
            </Link>
            <p className="mt-5 max-w-md text-slate-400 leading-relaxed">
              Cheap, reliable, and professional towing service available 24/7
              across Victoria — no job too big or too small.
            </p>

            <div className="mt-6 flex items-center gap-3 text-amber-400">
              <Star className="h-4 w-4 fill-current" />
              <span className="text-white font-semibold font-num">
                {SITE.rating}
              </span>
              <span className="text-sm text-slate-400">
                ({SITE.reviewsCount} reviews)
              </span>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-slate-400 font-bold">
              Services
            </h4>
            <ul className="mt-5 space-y-2">
              {[
                ["Car Towing", "/services#car-towing"],
                ["Emergency Towing", "/services#emergency-towing"],
                ["Roadside Assistance", "/services#roadside-assistance"],
                ["Caravan & Boat", "/services#caravan-transport"],
                ["Heavy Vehicles", "/services#heavy-vehicle-towing"],
              ].map(([label, to]) => (
                <li key={label}>
                  <Link
                    to={to}
                    className="text-slate-300 hover:text-white transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-xs uppercase tracking-[0.2em] text-slate-400 font-bold">
              Contact
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              {SITE.phones.map((p) => (
                <li key={p.tel} className="flex items-center gap-3">
                  <Phone className="h-4 w-4 text-amber-400" />
                  <a
                    href={`tel:${p.tel}`}
                    data-testid={`footer-tel-${p.tel}`}
                    className="text-white font-num hover:text-amber-300"
                  >
                    {p.number}
                  </a>
                  <span className="text-slate-500 text-xs">({p.label})</span>
                </li>
              ))}
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-amber-400" />
                <a
                  href={`mailto:${SITE.email}`}
                  className="hover:text-white"
                  data-testid="footer-email-link"
                >
                  {SITE.email}
                </a>
              </li>
              {SITE.locations.map((loc) => (
                <li key={loc.address} className="flex items-start gap-3">
                  <MapPin className="h-4 w-4 text-amber-400 mt-0.5" />
                  <span>{loc.address}</span>
                </li>
              ))}
              <li className="flex items-center gap-3">
                <Clock className="h-4 w-4 text-amber-400" />
                <span>{SITE.availability}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 border-t border-slate-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</p>
          <p>Servicing Victoria, Australia · ABN-registered local operator</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
